import React, {useState, useContext, useRef} from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Toolbar,
  Typography,
  Paper,
  Grid,
  Box,
  Tooltip,
  Button,
  Drawer,
} from '@material-ui/core/'
import {ArrowDropUp, ArrowDropDown, UnfoldMore} from '@material-ui/icons'
import {useTranslation} from 'react-i18next'
import {useHistory} from 'react-router-dom'
import CreateBarcodeSheet from '../BarcodeCreateSheet'
import {BarcodeUrlSkipContext} from '../../context/BarcodeUrlSkip'
import {useStyles, useToolbarStyles} from './BarcodeLibraryListView.styles'
import {BarcodeLabelRecordContext} from '../../context/BarcodeLabelRecord'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'
import {ToastMessageContext} from '../../context/ToastMessage'
import {UserContext} from '../../context/UserContext'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

function desc(a, b, orderBy) {
  if (typeof a[orderBy] === 'string') {
    a[orderBy].toLowerCase()
  }
  if (typeof b[orderBy] === 'string') {
    b[orderBy].toLowerCase()
  }
  if (b[orderBy] < a[orderBy]) {
    return -1
  }
  if (b[orderBy] > a[orderBy]) {
    return 1
  }
  return 0
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map(el => el[0])
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy)
}

export default function BarcodeLibraryListView(props) {
  const {t} = useTranslation()
  const classes = useStyles()
  const accountID = parseInt(window.localStorage.getItem('account_id'))
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('name')
  const [selected, setSelected] = useState([])
  const [page, setPage] = useState(0)
  const [hideTable, setHideTable] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const history = useHistory()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const {setUrlGoTo} = useContext(BarcodeUrlSkipContext)
  const {setBarcodeLabelRecord} = useContext(BarcodeLabelRecordContext)
  const {setBarcodeSheetRecord} = useContext(BarcodeSheetRecordContext)
  const toast = useContext(ToastMessageContext)
  const currentUser = React.useContext(UserContext)
  const [rowClick, setRowClick] = useState('')
  const refBtnAddNew = useRef(null)

  const EnhancedTableToolbar = values => {
    const classes = useToolbarStyles()
    const {title} = values

    return (
      <Toolbar>
        <Grid container item xs={12}>
          <Grid container item xs={10}>
            <div className={classes.title}>
              <Typography variant="h4">{title}</Typography>
            </div>
            <div>
              <Tooltip title="Hide Table">
                <Button color="primary" onClick={handleChangeHide} className={classes.buttonStyle}>
                  <Box marginTop={1}>
                    {hideTable
                      ? t('barcode.library.list-view.show')
                      : t('barcode.library.list-view.hide')}
                  </Box>
                </Button>
              </Tooltip>
            </div>
          </Grid>

          <Grid container item xs={2} justify="flex-end">
            <div className={classes.title}>
              <Button
                ref={refBtnAddNew}
                variant="outlined"
                disabled = {!validateBarcodePermission(currentUser, "can_add")}
                color="primary"
                onClick={handleAddNewClick}
              >
                {t('barcode.library.list-view.add-new')}
              </Button>
            </div>
          </Grid>
        </Grid>
      </Toolbar>
    )
  }

  function EnhancedTableHead(props) {
    const {order, orderBy, onRequestSort, headRows} = props

    const createSortHandler = property => event => {
      onRequestSort(event, property)
    }

    return (
      <TableHead>
        <TableRow>
          {headRows.map(row => (
            <TableCell
              key={row.id}
              align={row.id === 'groupAction' ? 'right' : 'left'}
              padding="default"
              sortDirection={orderBy === row.id ? order : false}
            >
              <TableSortLabel
                hidden={row.id === 'groupAction'}
                active
                onClick={createSortHandler(row.id)}
                IconComponent={
                  orderBy === row.id ? (order === 'desc' ? ArrowDropDown : ArrowDropUp) : UnfoldMore
                }
              >
                {t(row.label)}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    )
  }

  function handleChangeHide(event) {
    setHideTable(hideTable ? false : true)
  }

  function handleRequestSort(event, property) {
    const isDesc = orderBy === property && order === 'desc'
    setOrder(isDesc ? 'asc' : 'desc')
    setOrderBy(property)
  }

  function handleClick(event, name) {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      )
    }

    setRowClick(name)
    setSelected(newSelected)
  }

  function handleChangePage(event, newPage) {
    setPage(newPage)
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  function handleAddNewClick(event) {
    if(!validateBarcodePermission(currentUser, "can_add")){
      return;
    }
    setBarcodeLabelRecord('')
    setBarcodeSheetRecord('')
    if (props.showTable === 'automated') {
      setUrlGoTo('barcode-wizard-auto-form')
      history.push({pathname: 'barcode-wizard'})
    }
    if (props.showTable === 'fieldValue') {
      setUrlGoTo('barcode-wizard-field-value-form')
      history.push({pathname: 'barcode-wizard'})
    }
    if (props.showTable === 'sheets') {
      setDrawerOpen(true)
    }
    if (props.showTable === 'labels') {
      history.push({pathname: 'new-label', pageFrom: 'barcode-library'})
    }
  }

  function selectSheetCreate(sheet) {
    if (sheet) {
      toast.popMessage('Add Successful', 'success', refBtnAddNew.current)
    } else {
      toast.popMessage('An Error Occured while saving', 'error', refBtnAddNew.current)
    }
  }

  const toggleDrawer = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setDrawerOpen(open)
  }

  const rows = props.rowData

  //const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage)

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar title={props.title} />
        <div className={classes.tableWrapper}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={props.density === 'compress' ? 'small' : 'medium'}
            hidden={hideTable}
          >
            <EnhancedTableHead
              classes={classes}
              headRows={props.tableShow}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />

            <TableBody>
              {stableSort(rows, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const itemSelected = rowClick === row.name
                  const labelId = `enhanced-table-checkbox-${index}`

                  return (
                    <TableRow
                      hover
                      onClick={event => handleClick(event, row.name)}
                      role="checkbox"
                      aria-checked={itemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={itemSelected}
                    >
                      {Object.entries(row).map(([key, value]) => {
                        if (key === 'name') {
                          return (
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              padding="default"
                              key={key}
                            >
                              {value}
                            </TableCell>
                          )
                        } else {
                          return (
                            <TableCell align={key === 'groupAction' ? 'right' : 'left'} key={key}>
                              {value}
                            </TableCell>
                          )
                        }
                      })}
                    </TableRow>
                  )
                })}
              {rows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <Grid container item xs={12} justify="center">
                      No Results Found
                    </Grid>
                  </TableCell>
                </TableRow>
              )}

              {/* emptyRows > 0 && (
                <TableRow style={{ height: 49 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              ) */}
            </TableBody>
          </Table>
        </div>

        <Drawer anchor="right" open={drawerOpen}>
          <CreateBarcodeSheet
            toggleDrawer={toggleDrawer()}
            accountId={accountID}
            selectSheetCreate={selectSheetCreate}
          />
        </Drawer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'previous page',
          }}
          nextIconButtonProps={{
            'aria-label': 'next page',
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  )
}
